import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_TO_STARTER_RECOMMENDATIONS_CONFIG = defineFcm('supporter_to_starter_recommendations_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				systemPrompt: { type: 'string' },
				prompt: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							replacer: {
								type: 'enum',
								values: ['ask', 'description', 'location'] as const,
							},
							text: {
								type: 'string',
							},
						},
					},
				},
				options: {
					optional: true,
					type: 'object',
					shape: {
						model: {
							optional: true,
							type: 'string',
						},
					},
				},
			},
		}),
	)
	.withDefault({
		systemPrompt: '',
		prompt: [],
		options: { model: 'gpt-4' },
	})
	.toConfig();
